module.exports = "https://cdn.dove.it/_next/static/public/assets/features/feature_7.7db7ba24032b27b13bf4f1a66de1b605.jpg";